import React, { useEffect, useRef, useState } from 'react';
import { usePunctuality } from '../../../Hooks/Features/Punctuality/usePunctuality';
import LateArrival from '../../../components/Punctuality/LateArrival';
import DatePicker from 'react-multi-date-picker';
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from '../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import { monthsOptions, yearsOptions } from '../../../utils/Helper';
import { SkeletonDataTable } from '../../../components/Loader/Loader';
import { AgGridReact } from '@ag-grid-community/react';
import { useCommon } from '../../../Hooks/Common/useCommon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import CommonFilterDropdown from '../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown';
ModuleRegistry.registerModules([ClientSideRowModelModule, RowGroupingModule]);

const Punctuality = () => {
  const { userCode, popupOpne, setPopupOpen, DateRange, setDateRange, filterValues, setFilterValues, handleEvents, columnDefs, rowData, loader, GetEmployeeAttandance, selectedData, setSelectedData, attendanceSummary, GetEmployeeAttandanceSummary, setIsChanged, summaryLoader } = usePunctuality();
  const tagRef = useRef();
  const { checkPermission } = useCommon();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
  const datePickerRef = useRef(null);

  useEffect(() => {
    userCode && GetEmployeeAttandanceSummary();
    userCode && GetEmployeeAttandance()
    // eslint-disable-next-line
  }, [userCode])


  return (
    <div className='container-fluid' style={{ position: 'relative' }}>

      <div className="d-flex align-items-center justify-content-between gap-3 w-100 mt-2">
        <div className="d-flex align-items-center gap-2 flex-grow-1">
        </div>
        <div className="d-flex justify-content-end gap-2">
          <button className='button btn-default' onClick={() => { GetEmployeeAttandance(null, null, true); GetEmployeeAttandanceSummary() }} title="Refresh">
            <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
          </button>
          <button className='button btn-default' onClick={() => setShowFiltersDrawer(true)} title="Filters">
            <FontAwesomeIcon icon="fa-solid fa-filter" />
          </button>
        </div>
      </div>
      <div className='row mt-2'>
        <div className={`${attendanceSummary?.length > 0 ? "col-md-3 col-12 border" : "d-none"}`} style={{ height: "84vh", overflow: "auto" }}>
          {
            summaryLoader ? <SkeletonDataTable numSkeletons={10} /> :
              <table className='table-ulist'>
                <thead>
                  <tr>
                    <th></th>
                    <th>Employee</th>
                    <th className='text-center'>UnPunctual</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    attendanceSummary?.map((value, index) => {
                      return <tr key={index} style={{ cursor: "pointer" }} onClick={() => GetEmployeeAttandance(value?.user_code)}>
                        <td><img style={{ width: "18px", height: "18px", borderRadius: "50px" }} src={value?.image_url} alt='' /></td>
                        <td>{value?.user_display_name}</td>
                        <td className='text-center'>{value?.total_unpunctuality}</td>
                      </tr>
                    })
                  }
                </tbody>
              </table>
          }
        </div>
        <div className={`${attendanceSummary?.length > 0 ? "col-md-9 col-12" : "col-12"}`}>
          {
            loader ? <SkeletonDataTable numSkeletons={10} /> :
              <>
                {
                  <div className='estimate-grid'>
                    <div className="ag-theme-alpine aggrid-container" style={{ height: 'calc(100vh - 100px)' }}>
                      <AgGridReact
                        columnDefs={columnDefs}
                        rowData={rowData}
                        rowHeight={30}
                        headerHeight={30}
                        groupDefaultExpanded="-1"
                      // defaultColDef={{ flex: 2 }}
                      />
                    </div>
                  </div>
                }
              </>
          }
        </div>
      </div>
      <LateArrival popupOpne={popupOpne} setPopupOpen={setPopupOpen} GetEmployeeAttandance={GetEmployeeAttandance} selectedData={selectedData} setSelectedData={setSelectedData} currentUser={userCode} />

      {/* Right Panel Filters Drawer */}
      <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
        <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
          <div className="sk-drawer-header">
            <h5 className="sk-drawer-title">Filters</h5>
            <div className="d-flex align-items-center gap-2">
              <button className="sk-drawer-clear-btn" onClick={() => {
                setDateRange([]);
                setFilterValues((prev) => ({
                  ...prev,
                  month: [],
                  year: [new Date().getFullYear()],
                  project_leads: [],
                  users: [],
                  apiCall: true
                }));
              }}>Clear All</button>
              <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                <FontAwesomeIcon icon="fa-solid fa-xmark" />
              </button>
            </div>
          </div>
          <div className="sk-drawer-body">
            <div className='d-flex flex-column gap-4'>
              {/* Date Picker Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Date Range</div>
                <DatePicker
                  ref={datePickerRef}
                  value={DateRange}
                  onChange={(date) => {
                                            if (!date || date.length === 2) {
                                                setDateRange(date);
                    if (date && date.length === 2) {
                      datePickerRef.current?.closeCalendar();
                    }
                                            }
                                        }}
                  range
                  rangeHover
                  numberOfMonths={2}
                  style={{ width: "100%" }}
                  containerStyle={{ width: "100%" }}
                  inputClass="w-100 sk-input-dd"
                  placeholder="Select Dates"
                />
              </div>

              {/* Month & Year Filters */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Period</div>
                <div className="row g-3 mx-0">
                  <div className="col-12 px-1">
                    <MultiSelect
                      onChange={(e) => { setFilterValues((prev) => ({ ...prev, month: e.target.value })); setIsChanged(true) }}
                      options={monthsOptions}
                      placeholder="Month"
                      filter
                      filterInputAutoFocus
                      value={filterValues?.month}
                      optionLabel="label"
                      className="sk-multiselect w-100"
                      panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'month', filterValues?.month, () => { }, handleEvents)}
                    />
                  </div>
                  <div className="col-12 px-1 mt-2">
                    <MultiSelect
                      onChange={(e) => { setFilterValues((prev) => ({ ...prev, year: e.target.value })); setIsChanged(true) }}
                      options={yearsOptions}
                      filter
                      filterInputAutoFocus
                      placeholder="Year"
                      value={filterValues?.year}
                      optionLabel="label"
                      className="sk-multiselect w-100"
                      panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'year', filterValues?.year, () => { }, handleEvents)}
                    />
                  </div>
                </div>
              </div>

              {/* Dimensions Dropdown Filters */}
              <div className="sk-drawer-filter-group" ref={() => checkPermission('punctuality', tagRef)}>
                <div ref={tagRef} id='{"tabname": "punctuality", "data": "punctuality_lead_dropdown"}'>
                  <div className="task-list-filter-label">Dimensions</div>
                  <CommonFilterDropdown
                    fields={[
                      { key: "project_leads", label: "Leads", col: 12 },
                      { key: "users", label: "Users", col: 12 },
                    ]}
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sk-drawer-footer">
            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
              GetEmployeeAttandance();
              GetEmployeeAttandanceSummary();
              setShowFiltersDrawer(false);
            }}>Apply Filters</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Punctuality
